/**
 * @desc 查询主要物料设置
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.SettingMaterialPageRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.QuerySettingMaterialResponse>>> {
  return defHttp.post({
    url: '/web/setting/material/search',
    data,
  });
}

export function mock(
  data: defs.SettingMaterialPageRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.QuerySettingMaterialResponse>>> {
  return defHttp.post({
    url: '/mock/web/setting/material/search',
    data,
  });
}
